import { PRODUCT_STATUS } from "./constants";

export const PRODUCT_LIFECYCLE_STEPS = [
  { key: PRODUCT_STATUS.DRAFT, label: "Draft" },
  { key: PRODUCT_STATUS.INTERNAL_REVIEW, label: "Internal Review" },
  { key: PRODUCT_STATUS.PUBLISHED, label: "Published" },
  { key: PRODUCT_STATUS.OUT_OF_STOCK, label: "Out of Stock" },
  { key: PRODUCT_STATUS.ARCHIVED, label: "Archived" },
];

const STEP_INDEX = Object.fromEntries(PRODUCT_LIFECYCLE_STEPS.map((s, i) => [s.key, i]));

const ALIASES = {
  [PRODUCT_STATUS.SCHEDULED]: PRODUCT_STATUS.PUBLISHED,
  [PRODUCT_STATUS.UNPUBLISHED]: PRODUCT_STATUS.DRAFT,
};

export function normalizeProductStatus(status) {
  return String(status || PRODUCT_STATUS.DRAFT).toLowerCase();
}

export function getProductLifecycleStepIndex(status) {
  const s = normalizeProductStatus(status);
  const key = ALIASES[s] || s;
  return STEP_INDEX[key] ?? 0;
}

export function getProductLifecycleActions(status) {
  const s = normalizeProductStatus(status);
  const actions = {
    [PRODUCT_STATUS.DRAFT]: [
      { label: "Submit for review", target: PRODUCT_STATUS.INTERNAL_REVIEW, variant: "primary" },
    ],
    [PRODUCT_STATUS.INTERNAL_REVIEW]: [
      { label: "Publish now", target: PRODUCT_STATUS.PUBLISHED, variant: "success" },
      { label: "Return to draft", target: PRODUCT_STATUS.DRAFT, variant: "ghost" },
    ],
    [PRODUCT_STATUS.SCHEDULED]: [
      { label: "Publish now", target: PRODUCT_STATUS.PUBLISHED, variant: "primary" },
    ],
    [PRODUCT_STATUS.PUBLISHED]: [
      { label: "Unpublish", target: PRODUCT_STATUS.UNPUBLISHED, variant: "ghost" },
      { label: "Mark out of stock", target: PRODUCT_STATUS.OUT_OF_STOCK, variant: "danger" },
      { label: "View public page", action: "preview", variant: "outline" },
    ],
    [PRODUCT_STATUS.OUT_OF_STOCK]: [
      { label: "Republish", target: PRODUCT_STATUS.PUBLISHED, variant: "success" },
      { label: "Archive", target: PRODUCT_STATUS.ARCHIVED, variant: "outline" },
      { label: "View public page", action: "preview", variant: "outline" },
    ],
    [PRODUCT_STATUS.UNPUBLISHED]: [
      { label: "Publish", target: PRODUCT_STATUS.PUBLISHED, variant: "primary" },
      { label: "Archive", target: PRODUCT_STATUS.ARCHIVED, variant: "ghost" },
    ],
    [PRODUCT_STATUS.ARCHIVED]: [],
  };
  return actions[s] || actions[PRODUCT_STATUS.DRAFT];
}

export function computeStockStatus(quantity, threshold, preOrderAllowed) {
  if (preOrderAllowed && quantity <= 0) return "pre_order";
  if (quantity <= 0) return "out_of_stock";
  if (quantity <= threshold) return "low_stock";
  return "in_stock";
}
